import { AxiosError } from "axios";
import { useMutation } from "react-query";
import axiosClient from "../utils/axiosClient";

export const useSaveScreeningMutation = () => {
  return useMutation<
    { jobId: number},
    AxiosError<any>,
    {
      file: File;
      query: string;
    }
  >(
    ({ file, query }) => {
      const body = new FormData();

      body.append("file", file);
      
      body.append("query", query);
      
      return axiosClient
        .post(`/screening/action`, body, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          timeout: 60 * 1000, // 1min
        })
        .then(({ data }) => data);
    },
    {
      retry: false,
    }
  );
};
